
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 21.023l22-.035.003 2-22 .035-.003-2zM2.992 16.018l3-.005.006 4-3 .005-.006-4zM12.989 14.002l3-.005.01 6-3 .005-.01-6zM6.987 13.012l3-.005.011 7-3 .005-.01-7zM16.982 9.996l3-.005.016 10-3 .005-.016-10zM14.97 1.999l5-.008.009 5-2 .003-.005-3-3 .005-.003-2z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.404 13.792L.988 12.38 8.34 5.004l3.54 3.53 5.986-6.004 1.416 1.412-7.394 7.418-3.541-3.53-5.943 5.962z"}})])
          )
        }
      }
    